import * as React from 'react';

import {FormField} from 'shells/form/form-field';
import {TextField} from 'shells/textfield/textfield';

type Props = {
    value: string;
    onChange: (arg1: string) => void;
    label: string;
    onEnter?: () => void;
};

Username.defaultProps = {
    label: 'Username (your email address)',
};

export function Username(props: Props) {
    return (
        <FormField
            innerId='username'
            label={props.label}
            errorMessage={null} // TODO
        >
            <TextField
                // @ts-expect-error
                name='username'
                placeholder='test@example.com'
                title={props.label}
                type='text'
                autoFocus={true}
                value={props.value}
                onChange={props.onChange}
                onEnter={props.onEnter}
            />
        </FormField>
    );
}
